import { useState, useEffect } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Lightbulb, X, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function NudgeBanner() {
  const navigate = useNavigate();
  const [nudges, setNudges] = useState([]);
  const [dismissedKeys, setDismissedKeys] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadNudges() {
      try {
        const response = await fetch(`${API_URL}/api/nudges`, {
          credentials: 'include'
        });
        if (response.ok) {
          const data = await response.json();
          setNudges(data.items || []);
        }
      } catch (error) {
        console.error('Failed to load nudges:', error);
      } finally {
        setLoading(false);
      }
    }
    loadNudges();
  }, []);

  function dismiss(key) {
    setDismissedKeys([...dismissedKeys, key]);
  }

  function handleAction(action) {
    if (action === 'crm') navigate('/crm');
    else if (action === 'contracts') navigate('/contracts');
    else if (action === 'proofs') navigate('/proofs');
    else if (action === 'invoices') navigate('/invoices');
  }

  const visibleNudges = nudges.filter(n => !dismissedKeys.includes(n.key));

  if (loading || visibleNudges.length === 0) return null;

  // Show only the highest priority nudge
  const priorityOrder = { high: 0, medium: 1, low: 2 };
  const topNudge = visibleNudges.sort((a, b) => 
    (priorityOrder[a.priority] || 2) - (priorityOrder[b.priority] || 2)
  )[0];

  return (
    <Card className="bg-gradient-to-r from-indigo-500/20 to-purple-500/20 border-indigo-500/30" data-testid="nudge-banner">
      <CardContent className="py-3 px-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-indigo-500/20 rounded-lg">
            <Lightbulb className="w-4 h-4 text-indigo-400" />
          </div>
          <span className="text-white text-sm">{topNudge.text}</span>
        </div>
        <div className="flex items-center gap-2">
          {topNudge.action && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleAction(topNudge.action)}
              className="text-indigo-400 hover:text-indigo-300"
            >
              Take Action
              <ArrowRight className="w-3 h-3 ml-1" />
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => dismiss(topNudge.key)}
            className="text-slate-400 hover:text-white p-1"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}

export default NudgeBanner;
